import { LoadingSpinner, Typography } from '@neo4j-ndl/react';
import { fleetManagementApi, useActiveProjectSummary } from '@nx/state';
import { skipToken } from '@reduxjs/toolkit/query';

export const DeploymentsCounter = () => {
  const activeProject = useActiveProjectSummary();
  const { data, isLoading, error } = fleetManagementApi.useGetDeploymentsQuery(activeProject?.id ?? skipToken);

  if (isLoading) {
    return (
      <div className="flex items-center">
        <Typography variant="subheading-medium">(</Typography>
        <LoadingSpinner className="" />
        <Typography variant="subheading-medium">)</Typography>
      </div>
    );
  }

  if (data && data.length > 0 && !error) {
    return <Typography variant="subheading-medium">({data.length})</Typography>;
  }

  return <Typography variant="subheading-medium">(0)</Typography>;
};
